export const JAPANESE_KANJI_ID = 24;
export const JAPANESE_ROMAJI_ID = 23;
export const CHINESE_ID = 13;
export const ARABIC_ID = 10;
export const PERSIAN_ID = 38;
export const URDU_ID = 48;

export const isJapaneseLanguageId = (targetLanguageId: number | null | undefined): boolean =>
  targetLanguageId === JAPANESE_KANJI_ID || targetLanguageId === JAPANESE_ROMAJI_ID;

export const isArabicScriptLanguageId = (targetLanguageId: number | null | undefined): boolean =>
  targetLanguageId === ARABIC_ID || targetLanguageId === PERSIAN_ID || targetLanguageId === URDU_ID;

export const isCharacterTracingLanguageId = (
  targetLanguageId: number | null | undefined,
): boolean => isJapaneseLanguageId(targetLanguageId) || targetLanguageId === CHINESE_ID;
